<template>
  <div>
    <gc-order-list-base :orderList="orderList"
                        :show-product-contract-no="showProductContractNo"
                        @goToOrderDetail="handleGoToOrderDetail">
      <template #itemButton="order">
        <slot name="itemButton" v-bind="order"></slot>
        <gc-order-list-buttons-base :order-detail="order"
        @goToProgress="handleGoToOrderDetail"
        @downloadOrderText="handleDownloadOrderText"></gc-order-list-buttons-base>
      </template>
    </gc-order-list-base>
  </div>
</template>

<script>
import EMKT from '../../constant'
import GcOrderListBase from './components/GcOrderListBase.vue'
import GcOrderListButtonsBase from './components/GcOrderListButtonsBase.vue'
// import $ from 'jquery'
export default {
  props: {
    orderList: Array,
    showProductContractNo: Boolean
  },
  emits: ['goToOrderDetail', 'downloadOrderText'],
  components: { GcOrderListBase, GcOrderListButtonsBase },
  data () {
    return {
      emkt: EMKT
    }
  },
  mounted () {
  },
  computed: {},
  methods: {
    handleGoToOrderDetail (orderDetail) {
      this.$emit('goToOrderDetail', orderDetail)
    },
    handleDownloadOrderText (orderDetail) {
      this.$emit('downloadOrderText', orderDetail)
    }
  }
}
</script>

<style scoped>

.content-block {
  position: relative;
  margin-top: 0;
  margin-bottom: 10px;
  padding: 0 15px;
  border-radius: 10px;
  /*width: 100%;*/
  border: 0.5px solid #EFEEF3;
  background-color: #fff;
}


row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}

/* !!important!! order status style start --------------------*/
.alert-background {
  background-color: #FE654D;
}

.orange-background {
  background-color: #FF9401;
}

.green-background {
  background-color: #2ac845;
}

.tiny-font {
  font-size: 12px;
  transform: scale(0.8);
  transform-origin: right center;
}

.order-status {
  /*width:80px;*/
  margin-right: 10px;
  padding: 0 10px;
  line-height: 18px;
  height: 18px;
  border-radius: 10px;
  color: #fff;
  text-align: right;
  float: right;
}

/*!!important!! order status style end -----------------------------*/


.return-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 21px;
  text-align: center;
  font-size: 12px;
  background-color: #fff;
  border: 1px solid #5878fa;
}

.deep-text-color {
  color: #424242;
  font-size: 12px;
  /*font-weight: 500;*/
  font-weight: bold;
}

.block-item {
  /*height: 35px;*/
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}

.full-split-line {
  border-top: .5px solid #efeef3;
  margin-right: -15px;
  margin-left: -15px;
  height: 1px;
}

.light-text-color {
  color: #929292;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// GcOrderListWithActions.vue?52b02d4e